module.exports = __webpack_public_path__ + "img/IMPORT.295ae480.svg";